import { Fragment, useCallback, useContext, useRef, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import RefuelsList from "./RefuelsList";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { Button } from "rizzui";
import { Refuel } from "../../../type/entities/refuel-type";
import cn from "../../../utils/classNames";
import RefuelImportModal from "../components/RefuelImportModal";
import RefuelDeleteAllModal from "../components/RefuelDeleteAllModal";
import { HiOutlineTrash } from "react-icons/hi2";

const RefuelsListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [refuelSelected, setRefuelSelected] = useState<Refuel | null>(null);
    const [isOpenImportModal, setIsOpenImportModal] = useState(false);
    const [isOpenDeleteAllModal, setIsOpenDeleteAllModal] = useState(false);
    const refuelsTableRefetchRef = useRef<(() => void) | null>(null);
    const defaultFilters = {};

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de repostajes' },
        { name: 'Repostajes', href: menuRoutes.refuels?.path || '/refuels' },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    const registerTableRefetch = useCallback((fn: () => void) => {
        refuelsTableRefetchRef.current = fn;
    }, []);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de repostajes" breadcrumb={breadCrumb}>
                    <div className="flex gap-3 mt-4 md:mt-0">
                        {
                            userCan('delete_all', 'refuel') &&
                            (
                                <Button
                                    color="danger"
                                    onClick={() => setIsOpenDeleteAllModal(true)}
                                >
                                    <HiOutlineTrash className="w-4 h-4" />
                                    <span className="ms-2">Borrar todos los repostajes</span>
                                </Button>
                            )
                        }
                        {
                            userCan('create', 'refuel') &&
                            (
                                <Button
                                    color="primary"
                                    onClick={() => { 
                                        setIsOpenFormDrawer(true) 
                                        setRefuelSelected(null)
                                    }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Crear repostaje
                                </Button>
                            )
                        }
                    </div>
                </PageHeader>
                <RefuelsList 
                    openFormDrawer={isOpenFormDrawer} 
                    setOpenFormDrawer={setIsOpenFormDrawer}
                    refuelSelected={refuelSelected}
                    setRefuelSelected={setRefuelSelected}
                    registerTableRefetch={registerTableRefetch}
                    setIsOpenImportModal={setIsOpenImportModal}
                />
                <RefuelImportModal 
                    isOpen={isOpenImportModal} 
                    onClose={() => setIsOpenImportModal(false)} 
                    refetch={() => {
                        refuelsTableRefetchRef.current?.();
                    }} 
                />
                <RefuelDeleteAllModal 
                    isOpen={isOpenDeleteAllModal} 
                    onClose={() => setIsOpenDeleteAllModal(false)} 
                    refetch={() => {
                        refuelsTableRefetchRef.current?.();
                    }} 
                />
            </FiltersProvider>
        </Fragment>
    );
};

export default RefuelsListWrapper;